<template>
    <div>
        <Head />
        <Floating />

        <div class="wrapper">
            <section class="error-main">
                <div class="box">
                    <img src="/img/errorimg/img.svg" alt="">
                </div>
                <div class="text">
                    <h1>
                        <img class="logo_img" src="/img/errorimg/logo.png" alt="logo">
                    </h1>
                    <hr>
                    <p>抱歉！請您再重新檢視輸入的網址是否正確</p>
                    <p>您也可以回到<a href="javascript:history.go(-2)" title="上一頁">上一頁</a>或<router-link to="/" title="首頁">首頁</router-link></p>                    
                </div>
            </section>
        </div>

        <FooterMenu />
        <Footer />
    </div>
</template>

<script>
import Head from "@/components/Head.vue";
import Floating from "@/components/Floating.vue";
import FooterMenu from "@/components/FooterMenu.vue";
import Footer from "@/components/Footer.vue";
import Slick from "vue-slick";

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

const messages = {
    zh_tw: {
    },
    en: {
    },
};

const i18n = new VueI18n({
    locale: "zh_tw",
    messages,
});

export default {
    name: 'Error',
    i18n,
    metaInfo: {
        meta: [
            { property: "og:url", content: "" },
            {
                property: "og:type",
                content: "article",
            },
            {
                property: "og:title",
                content: "",
            },
            {
                property: "og:description",
                content: "",
            },
            {
                property: "og:image",
                content: "",
            },
            {
                property: "og:image:secure_url",
                content: "",
            },
            {
                property: "og:image:width",
                content: "",
            },
            {
                property: "og:image:height",
                content: "",
            },
            {
                property: "og:url",
                content: "",
            },
        ],
    },
    metaInfo() {
        return {
            meta: [
                { property: "og:url", content: this.og_url },
                {
                    property: "og:type",
                    content: "article",
                },
                {
                    property: "og:title",
                    content: this.og_title,
                },
                {
                    property: "og:description",
                    content: this.og_description,
                },
                {
                    property: "og:image",
                    content: this.og_image,
                },
                {
                    property: "og:image:secure_url",
                    content: this.og_image_secure_url,
                },
                {
                    property: "og:image:width",
                    content: this.og_image_width,
                },
                {
                    property: "og:image:height",
                    content: this.og_image_height,
                },
            ],
        };
    },
    components: {
        Head,
        Floating,
        FooterMenu,
        Footer,
        Slick,
    },
    data() {
        return {
        };
    },
    props: {
        isApp: {
            type: Boolean,
            default: false
        }
    },
    mounted: function () {
        if ($cookies.isKey("aow_site_lang")) {
            i18n.locale = $cookies.get("aow_site_lang");
            this.local = $cookies.get("aow_site_lang");
        } else {
            i18n.locale = "zh_tw";
            this.local = "zh_tw";
        }
    },
    methods: {},
}
</script>